function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0452 4C11.2697 4 12.2529 4.33882 12.9947 5.01646C13.7482 5.68221 14.125 6.60357 14.125 7.78052C14.125 8.94559 13.7541 9.83722 13.0123 10.4554C12.2705 11.0617 11.2874 11.3649 10.0628 11.3649L9.99217 12.738H7.81978L7.73147 9.70645H8.52625C9.55063 9.70645 10.3395 9.56973 10.8929 9.2963C11.4463 9.02286 11.723 8.52355 11.723 7.79835C11.723 7.27526 11.5699 6.85917 11.2638 6.55007C10.9694 6.24097 10.5632 6.08642 10.0452 6.08642C9.50353 6.08642 9.07965 6.23503 8.77351 6.53224C8.47915 6.82945 8.33197 7.2396 8.33197 7.76269H6.00063C5.98886 7.03749 6.14192 6.38958 6.45983 5.81893C6.77774 5.24829 7.24284 4.80247 7.85511 4.48148C8.47915 4.16049 9.20917 4 10.0452 4ZM8.89714 17C8.44972 17 8.07882 16.8633 7.78446 16.5899C7.50187 16.3045 7.36058 15.9538 7.36058 15.5377C7.36058 15.1216 7.50187 14.7769 7.78446 14.5034C8.07882 14.2181 8.44972 14.0754 8.89714 14.0754C9.3328 14.0754 9.69192 14.2181 9.97451 14.5034C10.2571 14.7769 10.3984 15.1216 10.3984 15.5377C10.3984 15.9538 10.2571 16.3045 9.97451 16.5899C9.69192 16.8633 9.3328 17 8.89714 17Z",
  fill: "white"
});

var SvgQuestionMark = function SvgQuestionMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestionMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question_mark.511c5233.svg";
export { ForwardRef as ReactComponent };